/* @flow */

import { call, put, takeLatest } from 'redux-saga/effects'

import type { Action, CustomerId } from '../../types'

import { sagaGet } from '../../fetch'
import { API_BLACKLIST } from '../../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
  ActionRequiresPropertyError,
} from '../../helpers'

import { getCustomersFromLegacyEntities } from '../../legacy'

import { sagaLogoutUnauthorizedUser } from '../logout'

import { intoCustomersStore } from '../../stores/customersStore'
import { intoBlacklistStore } from '../../stores/automation/blacklistStore'

export const FETCH_BLACKLIST_INTO_STORE: string =
  'opinary/FETCH_BLACKLIST_INTO_STORE'

export function fetchBlacklistIntoStore(customerId: CustomerId): Action {
  return {
    type: FETCH_BLACKLIST_INTO_STORE,
    customerId,
  }
}

export function* sagaFetchBlacklistIntoStore(
  action: Action
): Generator<*, void, *> {
  if (!(action && action.customerId)) {
    throw new ActionRequiresPropertyError(
      FETCH_BLACKLIST_INTO_STORE,
      'customerId'
    )
  }
  try {
    const response = yield call(
      sagaGet,
      `${API_BLACKLIST}?customer=${action.customerId}`
    )
    if (response == null) throw new SagaMalfunctionError()
    if (response.status === 401 || response.status === 403)
      yield call(sagaLogoutUnauthorizedUser)
    if (response.status !== 200) throw new BadResponseError(response)
    const blacklist = yield call([response, response.json])

    if (blacklist == null) throw new SagaMalfunctionError()

    yield put(
      intoCustomersStore(getCustomersFromLegacyEntities(blacklist.results))
    )
    yield put(intoBlacklistStore(blacklist))
  } catch (err) {
    yield call(sagaHandleError, err)
  }
}

export function* sagaRepeatedlyFetchBlacklistIntoStore(): Generator<
  *,
  void,
  *
> {
  yield takeLatest(FETCH_BLACKLIST_INTO_STORE, sagaFetchBlacklistIntoStore)
}



// WEBPACK FOOTER //
// ./src/sagas/automation/fetchBlacklist.js